import React, { useEffect, useRef } from 'react';
import { Dropdown } from 'src/UIKit';
import { TableHeader, TableHeaderItem } from 'src/components/TableHeader/TableHeader';
import { GroupBy } from '../../controllers/ReportsViewController';

interface TableHeaderControlsProps {
  groupBy: GroupBy;
  onGroupByChange: (groupBy: GroupBy) => void;
  onSearchChange?: (query: string) => void;
  searchQuery?: string;
  isLoading?: boolean;
}

const groupOptions: { value: GroupBy; title: string }[] = [
  { value: 'application', title: 'Application' },
  { value: 'company', title: 'Company' },
  { value: 'error_code', title: 'Error Code' },
];

export const TableHeaderControls: React.FC<TableHeaderControlsProps> = ({
  groupBy,
  onGroupByChange,
  onSearchChange,
  searchQuery,
  isLoading,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const hadFocusRef = useRef(false);

  useEffect(() => {
    if (inputRef.current && document.activeElement === inputRef.current) {
      hadFocusRef.current = true;
    }
  });

  useEffect(() => {
    if (hadFocusRef.current && inputRef.current && !isLoading) {
      if (document.activeElement !== inputRef.current) {
        inputRef.current.focus();
      }
    }
  }, [isLoading, searchQuery]);

  return (
    <TableHeader
      searchValue={searchQuery}
      onSearchChange={onSearchChange ? (_, value) => onSearchChange(value) : undefined}
      searchInputRef={inputRef}
      searchDisabled={isLoading}
      actions={
        <TableHeaderItem>
          <Dropdown
            label="Group By"
            value={groupBy}
            options={groupOptions}
            onChange={(_, value) => onGroupByChange(value)}
            size="small"
            margin="none"
          />
        </TableHeaderItem>
      }
    />
  );
};
